import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Grid, Typography, Button } from '@mui/material';
import { getPresignedUrlRead } from '../../api';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const EventMediaGallery = () => {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  // Hardcoded image URLs as provided
  const hardcodedImageUrls = [
    "event_media_image/IMG-20251127-WA0036_1764223488273.jpg",
    "event_media_image/ca0ca483-6f45-40b5-b40f-587046c2ffda_1764221649752.jpg",
    "event_media_image/HSSCHINGUS12_1764221762104.PNG",
    "event_media_image/Photo 03_1732699065186.jpg"
  ];

  // Fetch presigned URLs for the hardcoded images
  const fetchImages = async () => {
    setIsLoading(true);

    try {
      const imageData = await Promise.all(
        hardcodedImageUrls.map(async (mediaUrl, index) => {
          // Extract folder name and file name
          const folderName = mediaUrl.substring(0, mediaUrl.lastIndexOf('/'));
          const fileName = mediaUrl.substring(mediaUrl.lastIndexOf('/') + 1);

          // Fetch presigned URL
          const presignedUrl = await getPresignedUrlRead(folderName, fileName);

          return {
            url: presignedUrl?.data,
            alt: `Event Media Image ${index + 1}`,
            id: index
          };
        }),
      );

      // Filter out invalid URLs
      const validImageData = imageData.filter((item) => item.url);
      setImages(validImageData);
    } catch (error) {
      console.error('Error fetching images:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <div style={{ padding: '0 6%', textAlign: 'center', marginBottom: '60px' }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#7a5e34',
          marginBottom: '50px',
          fontSize: '30px',
          textAlign: 'center',
        }}
      >
        {t('media_gallery_events')}
      </Typography>

      {isLoading ? (
        <Box textAlign="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            {images.map((imageItem, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={imageItem.id}>
                <img
                  src={imageItem.url}
                  alt={imageItem.alt}
                  style={{
                    maxWidth: '80%',
                    minWidth: '80%',
                    minHeight: '200px',
                    maxHeight: '200px',
                    objectFit: 'cover',
                    borderRadius: '15px',
                    border: '1px solid black',
                    cursor: 'pointer',
                  }}
                  loading="lazy"
                />
              </Grid>
            ))}
          </Grid>

          <Box mt={3} textAlign="center">
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#B99744',
                color: 'black',
                fontWeight: 'bold',
                mb: 2,
                '&:hover': {
                  bgcolor: '#9F8239',
                },
              }}
              onClick={() => navigate('/media?type=events')}
            >
              {t('view_more')}
            </Button>
          </Box>
        </>
      )}
    </div>
  );
};

export default EventMediaGallery;